import 'magnific-popup';
import initFieldNumber from './field-number.js';
import initPlaceholder from './field-placeholders.js';

//Trigger for the popup with the video

$('.js-popup-video-trigger').magnificPopup({
	type: 'iframe',
	iframe: {
		markup: '<div class="mfp-iframe-scaler">' +
			'<div class="mfp-close"></div>' +
			'<iframe class="mfp-iframe" frameborder="0" allow="autoplay; encrypted-media"></iframe>' +
			'</div>',
	// Converts Youtube links to embeded videos in Magnific popup.
		patterns: {
			youtube: {
				index: 'youtube.com/',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1&mute=1&rel=0&showinfo=0&enablejsapi=1'
			},
			vimeo: {
				index: 'vimeo.com/',
				id: '/',
				src: '//player.vimeo.com/video/%id%?autoplay=1&muted=1'
			},
		}
	},
	callbacks: {
		beforeOpen: function() {
			$('body').css('overflow', 'hidden');
		},
		open: function() {
			var iframe = $('.mfp-iframe-scaler iframe');
		},
		beforeClose: function() {
			$('body').css('overflow', 'auto');
		}
	}
})

//Trigger for the popup with forms

$('.js-popup-trigger').magnificPopup({
	type: 'ajax',
	mainClass: 'main-popup',
	callbacks: {
		ajaxContentAdded: function() {
			initFieldNumber();
			initPlaceholder();
		},
		beforeOpen: function() {
			$('body').css('overflow', 'hidden');
		},
		beforeClose: function() {
			$('body').css('overflow', 'auto');
		}
	}
})

$('.open-popup-link').magnificPopup({
	type:'inline',
	// closeOnBgClick: true,
	// closeBtnInside: true,
	// showCloseBtn: true,
	midClick: false // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
});
